import { EMPTY_OBJECT } from '../../../../constants/common'
import { FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION } from '../../../../constants/form'
import { SIZE } from '../../../../constants/size'
import { getItemsIds } from '../../../../utils/common'
import { getEntityActionTypeSelectOptions } from '../../../Entity'
import { FormModal } from '../../../Form'

import {
  BUILDING_GROUP_EDIT_MANAGERS_FIELD_NAME_MANAGER,
  BUILDING_GROUP_EDIT_MANAGERS_FIELD_NAME_UPDATE_MANAGERS,
  QA_NAME_EDIT_MANAGERS_MODAL,
} from './BuildingGroupsEditManagersActionModal.constants'
import {
  getInitialValues,
  getValidationSchema,
} from './BuildingGroupsEditManagersActionModal.utils'
import { FormFields } from './FormFields'

function BuildingGroupsEditManagersActionModal({
  formFieldsProps: {
    actionTypes = Object.values(getEntityActionTypeSelectOptions()),
    ...formFieldsProps
  } = EMPTY_OBJECT,
  itemAction,
  users,
  onSubmit,
  ...restProps
}) {
  const initialValues = getInitialValues({ itemAction, users })

  const validationSchema = getValidationSchema({ initialValues, itemAction })

  function handleSubmit({ values }) {
    const payload = {
      [BUILDING_GROUP_EDIT_MANAGERS_FIELD_NAME_UPDATE_MANAGERS]:
        values[BUILDING_GROUP_EDIT_MANAGERS_FIELD_NAME_UPDATE_MANAGERS],
      ids: getItemsIds(
        values[BUILDING_GROUP_EDIT_MANAGERS_FIELD_NAME_MANAGER],
        'value'
      ),
    }

    onSubmit({
      payload,
      values,
    })
  }

  return (
    <FormModal
      {...restProps}
      Fields={FormFields}
      containerProps={{
        boxSize: SIZE.MEDIUM,
        qaName: QA_NAME_EDIT_MANAGERS_MODAL,
      }}
      formBodyProps={FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION}
      formFieldsProps={{ ...formFieldsProps, actionTypes }}
      formTitle='Modal.ChangeManagerTitleKey'
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    />
  )
}

export default BuildingGroupsEditManagersActionModal
